import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { Tooltip } from '@buildoutinc/blueprint-react/ui/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faUser, faUsers } from '@fortawesome/pro-regular-svg-icons';

export interface UsersAndTeams {
  everyone: boolean;
  teams?: string[];
  users?: string[];
}

interface BadgeListProps {
  values?: string[] | null;
}

interface UsersAndTeamsCellProps {
  usersAndTeams?: UsersAndTeams;
}

const VISIBLE_NAMES = 2;

export function BadgeList({ values }: BadgeListProps) {
  if (!values || values.length === 0) return <>---</>;

  return (
    <div className="d-flex gap-1 flex-wrap">
      {values.map(value => <Badge appearance="muted" key={value} variant="secondary">{value}</Badge>)}
    </div>
  );
}

export function UsersAndTeamsCell({ usersAndTeams }: UsersAndTeamsCellProps) {
  if (!usersAndTeams) return <>---</>;

  if (usersAndTeams.everyone) {
    return (
      <Badge appearance="muted" variant="secondary">
        <FontAwesomeIcon className="me-1" icon={faGlobe} />
        Everyone
      </Badge>
    );
  }

  const names = [
    ...(usersAndTeams.teams || []).map((name, index) => ({ key: `team-${index}`, name, icon: faUsers })),
    ...(usersAndTeams.users || []).map((name, index) => ({ key: `user-${index}`, name, icon: faUser }))
  ];
  if (names.length === 0) return <>---</>;

  const hidden = names.slice(VISIBLE_NAMES);

  return (
    <div className="d-flex gap-1 flex-wrap align-items-center">
      {names.slice(0, VISIBLE_NAMES).map(({ key, name, icon }) => (
        <Badge appearance="muted" key={key} variant="secondary">
          <FontAwesomeIcon className="me-1" icon={icon} />
          {name}
        </Badge>
      ))}
      {hidden.length > 0 && (
        <Tooltip>
          <Tooltip.Trigger delay={0} render={<span className="text-primary text-nowrap">+{hidden.length} more</span>} />
          <Tooltip.Content>
            {hidden.map(({ key, name, icon }) => (
              <div key={key}>
                <FontAwesomeIcon className="me-1" icon={icon} />
                {name}
              </div>
            ))}
          </Tooltip.Content>
        </Tooltip>
      )}
    </div>
  );
}
